import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/new-mail/Topbar.css";

const Topbar = () => {
//   const navigate = useNavigate();

//   const handleBackClick = () => {
//     navigate("/search-mail");
//   };

  return (
    <div className="new-mail-topbar">
      <div className="view-mail-header">
        <div className="title">
          <div className="text">New Mail</div>
          <div className="button1">
            <div className="attach">Attach</div>
            <div className="icon-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 18 18"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>
          <div className="button2">
            <div className="option">Option</div>
          </div>
          <div className="button3">
            <div className="preview">Preview</div>
          </div>
          <div className="button4">
            <div className="draft">Save to Draft</div>
          </div>
        </div>
        <div className="right-buttons">
          <div className="button5">
            <div className="save">Save</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
